export enum Dashboard {
  Agent = 'agent',
  AllianceGroup = 'alliance-group',
  MGA = 'mga',
  RMD = 'rmd',
  Manager = 'manager',
  /**
   * The caller's team, scoped server-side to their downline.
   *
   * Deliberately a new member rather than a remap of `Manager`: `Manager` maps to the
   * agency view in six copies of getDashboardView and is shared with the PWA manager
   * dashboard and the summary-details manager tab, so remapping it would silently
   * change three unrelated screens.
   */
  Team = 'team',
}

export const DASHBOARD_TITLE_LOOKUP = [
  {
    type: Dashboard.AllianceGroup,
    title: 'Alliance Group Production',
    summaryTitle: 'Alliance Group Summary',
  },
  {
    type: Dashboard.RMD,
    title: 'RMD Production',
    summaryTitle: 'RMD Summary',
  },
  {
    type: Dashboard.MGA,
    title: 'Agency Production',
    summaryTitle: 'Agency Summary',
  },
  {
    type: Dashboard.Manager,
    title: 'Agency Director Production',
    summaryTitle: 'Agency Director Summary',
  },
  {
    type: Dashboard.Agent,
    title: 'My Production',
    summaryTitle: 'My Summary',
  },
];
